export const PAGE_DETAILS:Record<string,Array<number>> ={
   page_window:[
    30,50
   ]
}

export const PAGE_SIZE = 30;